import axios from "axios";

const getApi = () => {
  if (!window.API_URL) {
    console.error("API_URL not loaded yet");
    throw new Error("API configuration not loaded");
  }
  return axios.create({
    baseURL: `${window.API_URL}/subscription`,
    headers: {
      "Content-Type": "application/json",
    },
  });
};

export const subscriptionApi = {
  getSubscription: async (token: string | null) => {
    const response = await getApi().get("/", {
      headers: { Authorization: token },
    });
    return response.data;
  },

  getPlans: async (token: string | null, charityId?: string) => {
    const response = await getApi().get("/plans", {
      params: charityId ? { charityId } : {},
      headers: { Authorization: token },
    });
    return response.data;
  },

  createSubscription: async (planName: string, billingInterval: string, token: string | null) => {
    const response = await getApi().post("/create", {
      planName,
      billingInterval,
    }, {
      headers: { Authorization: token },
    });
    return response.data;
  },

  updateSubscription: async (
    subscriptionId: string,
    newPlanName: string,
    newBillingInterval: string,
    token: string | null
  ) => {
    const response = await getApi().post("/update", {
      subscriptionId,
      newPlanName,
      newBillingInterval,
    }, {
      headers: { Authorization: token },
    });
    return response.data;
  },

  cancelSubscription: async (subscriptionId: string, token: string | null) => {
    const response = await getApi().post("/cancel", {
      subscriptionId,
    }, {
      headers: { Authorization: token },
    });
    return response.data;
  },

  resumeSubscription: async (token: string | null) => {
    const response = await getApi().post("/resume", {}, {
      headers: { Authorization: token },
    });
    return response.data;
  },

  /** Fetch plan limits + current usage counts for the charity */
  getUsage: async (token: string | null) => {
    const response = await getApi().get("/usage", {
      headers: { Authorization: token },
    });
    return response.data;
  },

  /** Submit manual project selection after a downgrade */
  submitProjectSelection: async (selectedProjectIds: number[], token: string | null) => {
    const response = await getApi().post("/project-selection", {
      selectedProjectIds,
    }, {
      headers: { Authorization: token },
    });
    return response.data;
  },
};

export const formatPrice = (amount: number, currency = "gbp") => {
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency: currency.toUpperCase(),
  }).format(amount / 100);
};

export const formatDate = (date: string | Date) => {
  return new Intl.DateTimeFormat("en-GB", {
    day: "numeric",
    month: "short",
    year: "numeric",
  }).format(new Date(date));
};